import { getJson } from '../helpers/RequestsHelper'
import { getName } from '../pages/WorkflowComponents/Inputs/DragDropHelpers'

export let publicApps = undefined
export let externalApps = undefined
export let appsWithTriggers = undefined
export let appsWithActions = undefined
export let underCertificationApps = undefined
export let supportedApps = undefined
export let votes = undefined

let initialized = false
export const initializeApps = async () => {
    //TODO: How to implement this in an async Syngleton way? If we call this function twice quickly it will run 2 requests
    if (initialized) {
        return
    }

    const path = process.env.REACT_APP_SERVER_BASE_URL + "/applications"
    const result = await getJson(path)
    if (result) {
        supportedApps = result.items.sort((a, b) => (a.name > b.name) ? 1 : -1)
        publicApps = supportedApps.filter(a => a.public).sort((a, b) => (a.name > b.name) ? 1 : -1)
        externalApps = publicApps.filter(a => !a.id.includes("simplyflows")).sort((a, b) => (a.name > b.name) ? 1 : -1)
        appsWithTriggers = publicApps.filter(a => a.hasTriggers).sort((a, b) => (a.name > b.name) ? 1 : -1)
        appsWithActions = publicApps.filter(a => a.hasActions).sort((a, b) => (a.name > b.name) ? 1 : -1)
        underCertificationApps = supportedApps.filter(a => !a.public).sort((a, b) => (a.name > b.name) ? 1 : -1)
        initialized = true
    }

    await loadVotes()
}

export let allActions = {}

export const getLoadedActions = (applicationId) => {
    return allActions[applicationId]
}

export const getActions = async (applicationId) => {

    //TODO: When should we clear those?
    if (allActions[applicationId]) {
        return allActions[applicationId]
    } else {
        const appActions = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/" + applicationId + "/actions")
        if (appActions.types) {
            Object.values(appActions.types).forEach(type => 
                {
                    type.application = applicationId
                    //populateTypes(type, type, appActions.types, appActions.popularFields, "")
                })
        }
        allActions[applicationId] = appActions
        return appActions
    }
}

export const updateName = (field) => {

    // let name = field.name
    // let words = name.split(/(?=[A-Z])/)

    // words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1)
    // if (words.length > 1) {
    //     for (let i = 1; i < words.length; i++) {
    //         const word = words[i]
    //         words[i] = word.charAt(0).toLowerCase() + word.slice(1)
    //     }
    // }
    // name = words.join(" ")
    //TODO: Remove this function
    field.name = getName(field)
}

export const populateTypes = (mainType, type, types, popularFields, idPrefix, namePrefix) => {
    if (popularFields) {
        type.popularFields = popularFields[type.id]
    }
    for (let j = 0; j < type.fields.length; j++) {
        let field = type.fields[j]
        field.id = idPrefix + field.id
        field.name = namePrefix + getName(field)
        if (field.dataType === "$ref") {
            field.type = mainType
            field.subtype = JSON.parse(JSON.stringify(types[field.ref]))
            populateTypes(mainType, field.subtype, types, popularFields, field.id + ".", " ")
        }
        if (field.dataType === "array") {
            if (field.items["type"]) {
                field.itemtype = field.type
            } else if (field.items["$ref"]) {
                field.itemtype = JSON.parse(JSON.stringify(types[field.items["$ref"]]))
                if (field.itemtype.id != type.id) {
                    //TODO: Resolve more complex cycle scenarios
                    populateTypes(field.itemtype, field.itemtype, types, popularFields, "", "")
                }
            }
        }
        field.typeId = mainType.id
    }
}

export const getVotes = (application) => {
    return votes[application]
}

const loadVotes = async () => {
    const path = process.env.REACT_APP_SERVER_BASE_URL + "/votes/application"
    const result = await getJson(path)
    if (result) {
        votes = {}
        for (let i = 0; i < result.length; i++) {
            const vote = result[i];
            votes[vote._id] = vote.total
        }
    }
}